import React from 'react';
import { ModalV1 } from 'ui/ModalV1';
import classnames from 'classnames';
import { StandardModal } from 'pureUi/Modal';
import { CloseBoldIcon } from 'ui/Icons/components/CloseBold.component';
import { theme } from '../../../tailwind.config';

export enum EVideoPlatform {
  VIMEO = 'VIMEO',
};

interface IVideoModalProps {
  type: EVideoPlatform;
  videoId: string;
  title: string;
  className?: string;
  onClose: () => void;
  renderAsContent?: boolean;
}

export const VideoModal: React.FC<IVideoModalProps> = ({
  type, videoId, title, className, onClose, renderAsContent
}) => {
  const videoPlatformMapping = {
    [EVideoPlatform.VIMEO]: 'https://player.vimeo.com/video/',
  };
  const videoUrl = videoPlatformMapping[type];

  if (!videoUrl) {
    const errorContent = (
      <div className="flex flex-col">
        {!renderAsContent && (
          <div className="modal-heading-container flex items-center justify-between gap-[20px] px-[20px] h-[67px]">
            <span className="modal-heading m-0 font-noe-display text-21px leading-[27px] text-black block">
              {title}
            </span>
            <CloseBoldIcon onClick={onClose} className="cursor-pointer min-w-[12px] min-h-[12px]" fill={theme.colors['brown-100']} />
          </div>
        )}

        <div className={classnames('video flex items-center justify-center bg-dark-black', renderAsContent ? 'w-full h-[300px]' : 'w-[960px] h-[540px]')}>
          <div className="text-container flex flex-col">
            <p className="font-hurmegeometric-sans text-[36px] leading-[41px] text-white-true font-bold m-0 text-center">Sorry</p>
            <p className="font-hurmegeometric-sans text-[24px] leading-[27px] text-white-true m-0 mt-[10px] text-center">There was a problem loading this video</p>
          </div>
        </div>
      </div>
    );

    if (renderAsContent) {
      return errorContent;
    }

    return (
      <StandardModal
        frameClassName={classnames(className)}
        className="transparent"
        onClose={onClose}
        focusTrapActive={false}
        showCloseButton={false}
        removePadding
      >
        {errorContent}
      </StandardModal>
    );
  }

  const videoContent = (
    <div className="flex flex-col">
      {!renderAsContent && (
        <div className="modal-heading-container flex items-center justify-between gap-[20px] px-[20px] h-[67px]">
          <span className="modal-heading m-0 font-noe-display text-21px leading-[27px] text-black block">
            {title}
          </span>
          <CloseBoldIcon onClick={onClose} className="cursor-pointer min-w-[12px] min-h-[12px]" fill={theme.colors['brown-100']} />
        </div>
      )}

      <div className="video flex">
        <iframe
          src={`${videoUrl}${videoId}`}
          width={renderAsContent ? '100%' : '960'}
          height={renderAsContent ? '300' : '540'}
          allow="autoplay; fullscreen;"
        ></iframe>
      </div>
    </div>
  );

  if (renderAsContent) {
    return videoContent;
  }

  return (
    <StandardModal
      frameClassName={classnames(className)}
      className="transparent"
      onClose={onClose}
      focusTrapActive={false}
      showCloseButton={false}
      removePadding
    >
      {videoContent}
    </StandardModal>
  )
}